import Container from '@/components/Container';
import DefaultContentTemplate from '@/components/DefaultContentTemplate';

import PageHeader from '@/components/PageHeader';
import {
  AboutPageDefaultContentTemplateDynamicZone,
  Maybe,
  SurveyMethodologyDefaultContentTemplateDynamicZone,
} from '@/graphql/generated/graphql';

type DefaultContentTemplatePageType = {
  template?: Array<
    Maybe<AboutPageDefaultContentTemplateDynamicZone | SurveyMethodologyDefaultContentTemplateDynamicZone>
  > | null;
  title: string;
};

const DefaultContentTemplatePage = ({ template, title }: DefaultContentTemplatePageType) => {
  if (!template) {
    return null;
  }

  return (
    <>
      <Container className="mt-sh-60 !gap-y-0">
        <div className="col-span-12 gap-4 lg:col-start-3 lg:col-end-11">
          <PageHeader title={title} url="/" type="none" />
        </div>
        <div className="col-span-12 aspect-video gap-4 lg:col-start-3 lg:col-end-11">
          {template ? <DefaultContentTemplate fitContent content={template} idBodyDivider={false} /> : null}
        </div>
      </Container>
    </>
  );
};

export default DefaultContentTemplatePage;
